import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import TextFieldForms from "../Forms/TextFieldForms";
import InputAdornment from "@material-ui/core/InputAdornment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import PaymentMethod from "./PaymentMethod";
import Divider from "@material-ui/core/Divider";
import { updateSpMerchant } from "../../store/SpMerchantApi";
import cloudStore, { cloudStoreEvents } from "../../store/CloudStore";

function PosPaymentMethods(props) {
  const [newPaymentMethodName, setNewPaymentMethodName] = React.useState(null);
  const styling = JSON.parse(props.spMerchant.styling ?? "{}") ?? {};

  const [paymentMethods, setPaymentMethods] = React.useState(styling.payment_methods ? styling.payment_methods : []);

  const onChangeSpMerchant = () => {
    let newSpMerchant = {
      ...cloudStore.merchant.sp_merchants.find((spMerchantCloud) => spMerchantCloud.id === props.spMerchant.id),
    };
    let newPaymentMethods = JSON.parse(newSpMerchant.styling)
      ? JSON.parse(newSpMerchant.styling).payment_methods
      : null;
    setPaymentMethods(newPaymentMethods);
  };

  const [errorMessage, setErrorMessage] = React.useState(null);

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
  }, []);

  return (
    <div>
      <TextFieldForms
        value={newPaymentMethodName ?? ""}
        onChange={(e) => {
          setNewPaymentMethodName(e.target.value);
        }}
        label={props.intl.formatMessage({ id: "create_payment_method" })}
        helperText={errorMessage}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AddCircleIcon
                onClick={() => {
                  let newPaymentMethods = [...paymentMethods];
                  if (newPaymentMethods.find((newPaymentMethod) => newPaymentMethod.name === newPaymentMethodName)) {
                    setErrorMessage(props.intl.formatMessage({ id: "payment_method_already_exists" }));
                  } else {
                    newPaymentMethods.push({ name: newPaymentMethodName, open_cash_drawer: false });
                    updateSpMerchant(props.spMerchant, { styling: { payment_methods: newPaymentMethods } });
                    setNewPaymentMethodName(null);
                    setErrorMessage(null);
                  }
                }}
                color={"primary"}
              />
            </InputAdornment>
          ),
        }}
      />

      <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
      {paymentMethods &&
        Array.isArray(paymentMethods) &&
        paymentMethods.map((paymentMethod) => (
          <PaymentMethod
            paymentMethod={paymentMethod}
            handleUpdatePaymentMethods={(newPaymentMethod) => {
              let newPaymentMethods = [...paymentMethods];
              let index = newPaymentMethods.map((paymentMethod) => paymentMethod.name).indexOf(paymentMethod.name);
              newPaymentMethods.splice(index, 1, newPaymentMethod);
              updateSpMerchant(props.spMerchant, { styling: { payment_methods: newPaymentMethods } });
            }}
            handleRemovePaymentMethod={() => {
              let newPaymentMethods = [...paymentMethods];
              let index = newPaymentMethods.map((paymentMethod) => paymentMethod.name).indexOf(paymentMethod.name);
              newPaymentMethods.splice(index, 1);
              updateSpMerchant(props.spMerchant, { styling: { payment_methods: newPaymentMethods } });
            }}
          />
        ))}
    </div>
  );
}

export default withIntl(PosPaymentMethods);
